import { AiSettingsTab } from './AiSettingsTab';
import { GeneralInformationTab } from './GeneralInformationTab/GeneralInformationTab.main';
import {
  getSalaryFrameHost,
  SalarySettingsTab,
  SALARY_SETTINGS_LABEL,
} from './SalarySettingsTab';

export { GeneralInformationTab };
export { AiSettingsTab };
export { getSalaryFrameHost, SalarySettingsTab, SALARY_SETTINGS_LABEL };
